import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import train from "../assets/train.png";
import "./styles/LandingPage.css";
import logobreakdown from '../assets/logobreakdown.png';
import WesiteFooter from "../components/WebsiteFooter";

const LandingPage = ({ productsData, products }) => {
  const [categories, setCategories] = useState([]);
  const [isDropdownActive, setDropdownActive] = useState(false);
  const navigate = useNavigate();

  const toggleDropdown = () => {
    setDropdownActive((prevState) => !prevState);
  };

  const redirectTrigger = (path) => {
    const timestamp = new Date();
    window.gtag("event", `${path}_Click`, { 'timestamp': timestamp.toLocaleString(), "click": path });
    navigate(`Collections/${path}`);
  };

  useEffect(() => {
    const fetchData = async () => {
      try {
        if (productsData) {
          const categoryMap = {}; // Temporary object to store categories
          productsData.forEach((product) => {
            if (!categoryMap[product.Category]) {
              categoryMap[product.Category] = product.Img?.[0] || "/placeholder.jpg";
            }
          });

          setCategories(categoryMap); // Merge with previous state
        }
      } catch (error) {
        console.error("Error fetching categories:", error);
      }
    };

    fetchData();
  }, [productsData, setCategories]);

  return (
    <div className="homePage">
      {/* Hero Section */}
      <section className="section1">
        <div className="section1Content">
          <h1>Savor the Flavors of Konkan</h1>
          <p>Explore authentic local specialties along the Konkan Railway Route</p>
          <button onClick={() => redirectTrigger(`All`)} className="section1ShopNowBtn">Shop Now</button>
        </div>
      </section>

      <section className="section3" id="category">
        <div className="menu" id="menu" onClick={toggleDropdown}>
          <h1>Shop by Category</h1>
          {isDropdownActive && (
            <div className="list" id="ddl">
              {categories &&
                Object.keys(categories).map((category) => (
                  <div
                    key={category}
                    className={`categoryCard ${category.replace(/\s+/g, "")}`}
                    onClick={() =>
                      redirectTrigger(`Category/${category}`)
                    }
                  >
                    {productsData
                      .filter((product) => product.Category === category) // Filter by category
                      .map((product, index) => (
                        product.isCombo ? (
                          <div className="category-card" key={index}>
                            {Array.isArray(product.Products) &&
                              product.Products.map((productName, i) => {
                                const comboProduct = products?.[productName]; // Get combo product details
                                return (
                                  <img
                                    key={i}
                                    src={comboProduct?.Img?.[0] || "/placeholder.jpg"}
                                    alt={comboProduct?.Name || "Unknown Product"}
                                    className="home-combo-image"
                                  />
                                );
                              })}
                          </div>
                        ) : (
                          <img
                            key={index}
                            src={categories[category]}
                            alt={category}
                            className="menuCardImage"
                          />
                        )
                      ))}

                    <div className="categoryOverlay">
                      <span className="categoryCardText">{category}</span>
                    </div>
                  </div>
                ))}
            </div>
          )}
        </div>
      </section>

      <section className="section2" onClick={() => redirectTrigger(`Destination`)}>
        <h1>Shop By Destination</h1>
      </section>

      <section className="section4" id="aboutus">
        <div className="section4Content">
          <div className="section4ImageContainer">
            <img src={train} alt="train" className="section4Image" />
          </div>
          <div className="section4TextContainer">
            <h1>About Us</h1>
            <p>Our story begins not with a train journey, but with generations of families along the Konkan coast, entrusted with the secrets of spice. For centuries, these families have cultivated the land, nurtured the chilies under the warm sun, and hand-picked the fragrant cardamom pods. Their knowledge, passed down through generations, guides us as we source the purest spices from these very same farms. We travel the Konkan not as tourists, but as partners, ensuring each ingredient embodies the rich heritage and vibrant spirit of this coastal haven.</p>
          </div>
        </div>
      </section>
      <section className="section5">
        <div className="section5Content">
          <div className="section5TextContainer">
            <h4>The Leaf</h4>
            <p>Represents organic farming, sustainability, and the natural environment. It communicates a commitment to eco-friendly practices and a connection to nature.</p>
            <h4>The Sea</h4>
            <p>Represents the Arabian Sea, conveying a sense of location and geographical significance. It is associated with the coastal regions and the importance of the sea in the Konkan context.</p>
            <h4>The Train</h4>
            <p>Represents the Konkan Railway, emphasizing transportation, connectivity, and the region's infrastructure. It signifies progress, movement, and development.</p>
          </div>
          <div className="section5ImageContainer">
            <img src={logobreakdown} alt="logobreakdown" className="section5Image" />
          </div>
        </div>
      </section>
      <WesiteFooter />
    </div>
  );
};

export default LandingPage;

